import { render, staticRenderFns } from "./UserSingle.vue?vue&type=template&id=45d17156&scoped=true&"
import script from "./UserSingle.vue?vue&type=script&lang=js&"
export * from "./UserSingle.vue?vue&type=script&lang=js&"
import style0 from "./UserSingle.vue?vue&type=style&index=0&id=45d17156&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d17156",
  null
  
)

component.options.__file = "UserSingle.vue"
export default component.exports